import React from "react";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";

export default function Instalaciones() {
  return (
    <div id="instalaciones" className="text-center">
        <Seo
  title="Instalaciones | Pistas, boxes y paddocks"
  description="Conoce nuestras pistas, cuadras, guadarnés y zonas comunes. Entorno seguro y cuidado para caballo y jinete."
  path="/instalaciones"
  image="https://madridcampogrande.es/og/default.jpg"
/>
<BreadcrumbLd
  items={[
    { name: "Inicio", path: "/" },
    { name: "Instalaciones", path: "/instalaciones" },
  ]}
/>
      <div className="container">
        {/* Título */}
        <div className="section-title" style={{ marginBottom: 16 }}>
          <h2>Instalaciones</h2>
          <p style={{ maxWidth: 820, margin: "0 auto" }}>
            Contamos con instalaciones completas para la práctica de la
            equitación y el disfrute del entorno.
          </p>
        </div>

        {/* Galería de 3 fotos */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-sm-4">
            <img
              src="/img/portfolio/unnamed.jpg"
              alt="Instalaciones 1"
              style={{
                width: "100%",
                borderRadius: 12,
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                marginBottom: 20,
              }}
            />
          </div>
          <div className="col-sm-4">
            <img
              src="/img/portfolio/unnamed_2.jpg"
              alt="Instalaciones 2"
              style={{
                width: "100%",
                borderRadius: 12,
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                marginBottom: 20,
              }}
            />
          </div>
          <div className="col-sm-4">
            <img
              src="/img/portfolio/unnamed_3.jpg"
              alt="Instalaciones 3"
              style={{
                width: "100%",
                borderRadius: 12,
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                marginBottom: 20,
              }}
            />
          </div>
        </div>

        {/* Texto extra opcional */}
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <p style={{ fontSize: 16 }}>
              Disponemos de pistas de arena, caminadores, rutas por el entorno,
              zona social y vestuarios. Todo preparado para ofrecer la mejor
              experiencia a jinetes y visitantes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
